<template>
  <footer class="footer" id="footer">
    © FiveStones, a Numiracle Group company,<br class="footer-br" />
    all rights reserved. Privacy Policy
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {}
  }
}
</script>

<style scoped lang="scss">
@import '~bootstrap/scss/bootstrap-grid';
.footer {
  font-size: 10px;
  color: #ffffff;
  background: #333;
  padding: 5px;
  text-align: center;
  @include media-breakpoint-up(md) {
    font-size: 12px;
    padding: 10px;
  }
  &-br {
    display: inline-block;
    @include media-breakpoint-up(md) {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue